/**
 * This is a direct copy from https://github.com/sindresorhus/camelcase
 * Because this wasn't using ES5 syntax and would crash in IE11.
 */

const preserveCamelCase = (inpt) => {
	let isLastCharLower = false;
	let isLastCharUpper = false;
	let isLastLastCharUpper = false;

	let input = inpt;

	for (let ii = 0; ii < input.length; ii += 1) {
		const c = input[ii];

		if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
			input = `${input.slice(0, ii)}-${input.slice(ii)}`;
			isLastCharLower = false;
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = true;
			ii += 1;
		} else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
			input = `${input.slice(0, ii - 1)}-${input.slice(ii - 1)}`;
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = false;
			isLastCharLower = true;
		} else {
			isLastCharLower = c.toLowerCase() === c;
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = c.toUpperCase() === c;
		}
	}

	return input;
};

const main = (inpt, opt) => {
	let input = inpt;

	const options = Object.assign(
		{
			pascalCase: false,
		},
		opt
	);

	const postProcess = (x) => (options.pascalCase ? x.charAt(0).toUpperCase() + x.slice(1) : x);

	if (Array.isArray(input)) {
		input = input
			.map((x) => x.trim())
			.filter((x) => x.length)
			.join("-");
	} else {
		input = input.trim();
	}

	if (input.length === 0) {
		return "";
	}

	if (input.length === 1) {
		return options.pascalCase ? input.toUpperCase() : input.toLowerCase();
	}

	if (/^[a-z\d]+$/.test(input)) {
		return postProcess(input);
	}

	const hasUpperCase = input !== input.toLowerCase();

	if (hasUpperCase) {
		input = preserveCamelCase(input);
	}

	input = input
		.replace(/^[_.\- ]+/, "")
		.toLowerCase()
		.replace(/[_.\- ]+(\w|$)/g, (m, p1) => p1.toUpperCase());

	return postProcess(input);
};

export default main;
